export const env = import.meta.env.VITE_ENVIRONMENT;
export const isProduction = env === 'production';
export const isLocal = env === 'local';
export const apiUrl = import.meta.env.VITE_API_URL;
export const orchUrl = import.meta.env.VITE_ORCH_URL;
export const showLogs = import.meta.env.VITE_SHOW_LOGS === 'true';
export const apiTimeout = import.meta.env.VITE_API_TIMEOUT
  ? parseInt(import.meta.env.VITE_API_TIMEOUT, 10)
  : undefined;
